import React from 'react';

export function PromptModal({ promptModal, setPromptModal }) {
    if (!promptModal) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setPromptModal(null)}>
            <div style={{ background: '#fff', padding: 16, minWidth: 520, maxWidth: 960, maxHeight: '80vh', overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <div style={{ fontWeight: 600 }}>Prompt • Exchange {promptModal.exchange_seq}</div>
                    <button onClick={() => setPromptModal(null)}>Close</button>
                </div>
                <div style={{ fontSize: 12, color: '#5F6368', marginBottom: 8 }}>
                    <span style={{ marginRight: 12 }}>type: {promptModal.prompt.prompt_type || 'text'}</span>
                    {Number.isFinite(promptModal.prompt.bytes) && <span>bytes: {promptModal.prompt.bytes}</span>}
                </div>
                <div style={{ marginBottom: 8 }}>
                    <button className="btn-small" onClick={() => {
                        try { navigator.clipboard.writeText(String(promptModal.prompt.prompt_text || '')); } catch (_) { }
                    }}>Copy</button>
                    <button className="btn-small" style={{ marginLeft: 8 }} onClick={() => setPromptModal({ ...promptModal, wrap: !promptModal.wrap })}>{promptModal.wrap ? 'No Wrap' : 'Wrap lines'}</button>
                </div>
                <pre style={{ whiteSpace: promptModal.wrap ? 'pre-wrap' : 'pre', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', fontSize: 12, lineHeight: 1.5, background: 'var(--color-bg-base)', padding: 12, border: '1px solid #E8EAED', borderRadius: 6 }}>
                    {String(promptModal.prompt.prompt_text || '').replace(/\\n/g, '\n')}
                </pre>
            </div>
        </div>
    );
}
